// The CTA hands the URL to `window.location.assign`, so it must be a real web address:
// a relative string resolves against our own origin and dead-ends, and `javascript:`
// would execute. Backend-owned, but a dropped verdict is the safer failure.
export function isOpenable(raw: string): boolean {
  try {
    const { protocol, host } = new URL(raw)
    return host !== '' && (protocol === 'https:' || protocol === 'http:')
  } catch {
    return false
  }
}
